// extracted by mini-css-extract-plugin
export default {"root":"AddingDocument_root__tRQLC"};